<template>
  <a href="#" v-on:click="trackClick" class="snipcart-checkout icons clickable">
    <i class="ti-shopping-cart" style="font-size:24px"></i>
    <span class="snipcart-total-price">$0.00</span>
    (<span class="snipcart-items-count">0</span>)
  </a>
</template>

<script>
export default {
  methods: {
    trackClick (e) {
      console.log('View Cart')
      window.analytics.track('ViewCart')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CartButton.vue